import React from 'react';
import { getNextSortPatch, getSortIndicator } from '../../utils/listState';

function TableSortButton({
  children,
  currentOrder,
  currentSort,
  defaultAscFields = [],
  field,
  onChange,
}) {
  return (
    <button
      className="table-sort-button"
      onClick={() => onChange(getNextSortPatch({
        currentSort,
        currentOrder,
        field,
        defaultAscFields,
      }))}
      type="button"
    >
      {children}
      {getSortIndicator(currentSort, currentOrder, field)}
    </button>
  );
}

export default TableSortButton;
